<template>
  <div class="SideMenu_vue side-menu d-flex flex-column">
    <router-link
        class="side-menu-button"
        :to="{ path: '/app/home', query: { time: Date.now() } }"
    >
      <div class="button-wrapper pt-3" style="margin-bottom: 26px;">
        <div class="text-center">
          <img width="205" class="" :src="getImgUrl('Acounto_logo.svg')"/>
        </div>
      </div>
    </router-link>

    <router-link
        v-for="item in menuItems"
        :key="item.router"
        class="side-menu-button"
        :to="item.router"
    >
      <div class="button-wrapper my-2">
        <div class="button-content">
          <div class="icon-wrapper mx-2" style="width: 25px">
            <i :class="item.icon"></i>
          </div>
          <div class="link-text ml-2">{{ $cte(item.label) }}</div>
        </div>
      </div>
    </router-link>

    <router-link
        class="side-menu-button"
        v-if="!!getActiveCompany"
        :to="'/app/profile'"
    >
      <div class="button-wrapper my-2">
        <div class="button-content">
          <div class="icon-wrapper mx-2" style="width: 25px">
            <div
                class="company-icon"
                :style="'background-color:#a9e952'"
            >
              <div class="">
                {{ getFirstChar(getActiveCompany.name) }}
              </div>
            </div>
          </div>
          <div class="link-text text-dots ml-2">
            {{ getActiveCompany.shortName }}
          </div>
        </div>
      </div>
    </router-link>

    <router-link
        v-if="Util.doesJwtHasBoRoleOrOriginalUserId()"
        class="side-menu-button"
        to="/app/impersonation"
    >
      <div class="button-wrapper my-2">
        <div class="button-content">
          <div class="icon-wrapper _w-25 mx-2" style="width: 25px">
            <i class="fal fa-mask"></i>
          </div>
          <div class="link-text _w-75 ml-2">Megszemélyesítés</div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import {menuItems} from "@/constants/menuItems";
import {mapGetters} from "vuex";
import Util from "@/utils/Util";

export default {
  name: "SideMenu",
  props: {
    headerIcon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeRouter: "/app/home",
      menuItems,
      Util,
      intervalPointer: undefined,
    };
  },
  methods: {
    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    getFirstChar(str) {
      if (!!str && str.length > 0) {
        return str.charAt(0);
      } else {
        return "";
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.intervalPointer);
  },

  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
};
</script>

<style scoped>
.side-menu {
  width: 300px;
  height: 100vh;
  padding: 0px 20px;
}

.button-wrapper {
  width: 100%;
}

.button-content {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #252734;
  padding: 10px;
}

.icon-wrapper {
  display: inline-block;
  text-align: center;
  //color: #252734; /* override the active state color */
}

.link-text {
  font-family: "JumperLight";
  display: inline-block;
  //color: #252734; /* override the active state color */
}

a {
  color: #252734;
}

a:hover, .button-content:hover {
  color: #b2ec5d !important;
  text-decoration: none;
}

a.active, .link-text.active {
  color: #b2ec5d !important;
}

.menu-image {
  //width: 1em;
  //filter: grayscale(100%);
}

a.active .menu-image {
  color: #b2ec5d !important;
  //filter: grayscale(0%);
}

.active .button-content {
  color: #b2ec5d;
  background-color: #252734 !important;
  border-radius: 32px;
}

.max-width {
  width: max-content;
}

.company-icon {
  display: inline-block;
  color: #ffffff;
  padding-top: 3px;
  /*padding: 2px 7px 2px 7px;*/
  width: 21px;
  height: 21px;
  font-size: 11px;
  border-radius: 50%;
}

.hide-version-dot {
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: 0 0 0 0 !important;
}
</style>
